export const WHO_IS_IT_FOR_KEY = 'firstPurchaseTarget'
export const ATTRIBUTION_SURVEY_KEY = 'Attribution Survey'

export const QUIZ_STEPS = {
  INTRO: 'intro',
  WHO_IS_IT_FOR: 'who-for',
  CHOOSE_GIFT: 'choose-gift',
  NAME: 'name',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone',
  ATTRIBUTION_SURVEY: 'attribution',
  DIRECT_SMS_FLOW: 'sms',
} as const
export type QUIZ_STEPS = (typeof QUIZ_STEPS)[keyof typeof QUIZ_STEPS]

export const WHO_IS_IT_FOR_OPTIONS = {
  ME: 'me',
  GIFT: 'gift',
}

export enum GIFT_PRODUCT_OPTIONS {
  PICK_YOURSELF = 'pick yourself',
  GIFT_CARD = 'gift card',
}
